import React, { useState } from 'react';
import './MonitoramentoModernTooltip.css';

/**
 * Tooltip moderno (fundo branco + seta) — escopo monitoramento.
 */
export function MonitoramentoModernTooltip({
  label,
  osList = null,
  placement = 'top',
  className = '',
  hideOnClick = false,
  suppress = false,
  children
}) {
  const [clickedHidden, setClickedHidden] = useState(false);
  const isSuppressed = suppress || (hideOnClick && clickedHidden);

  const items = Array.isArray(osList)
    ? [...new Set(osList.map((os) => String(os).trim()).filter(Boolean))]
    : [];

  return (
    <span
      className={[
        'monitoramento-modern-tooltip-host',
        `monitoramento-modern-tooltip-host--${placement}`,
        isSuppressed ? 'monitoramento-modern-tooltip-host--suppressed' : '',
        className
      ].filter(Boolean).join(' ')}
      onPointerDown={hideOnClick ? () => setClickedHidden(true) : undefined}
      onPointerLeave={hideOnClick ? () => setClickedHidden(false) : undefined}
    >      {children}
      <span className="monitoramento-modern-tooltip" role="tooltip">
        <span className="monitoramento-modern-tooltip-label">{label}</span>
        {items.length > 0 ? (
          <span className="monitoramento-modern-tooltip-os-list">
            {items.map((os) => (
              <span key={os} className="monitoramento-modern-tooltip-os">{os}</span>
            ))}
          </span>
        ) : null}
      </span>
    </span>
  );
}

export function collectOsByCondition(activities, field) {
  if (!Array.isArray(activities)) return [];
  return [...new Set(
    activities
      .filter((act) => {
        const val = act?.[field];
        if (val == null) return false;
        const s = String(val).trim();
        return s !== '' && s.toLowerCase() !== 'null';
      })
      .map((act) => (act?.label != null ? String(act.label).trim() : ''))
      .filter(Boolean)
  )];
}
